import { render } from "./AdsPerQuarterReports.vue?vue&type=template&id=8e355158&ts=true"
import script from "./AdsPerQuarterReports.vue?vue&type=script&lang=ts"
export * from "./AdsPerQuarterReports.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__